export const starcoin_contract_address = "0xb987F1aB0D7879b2aB421b98f96eFb44"